import React from 'react'
import { Avatar } from "n2-styles";

const PrepressListItem = ({ job }) => {
  const {
    avatar,
    color_class,
    color_type,
    deadline_day,
    formatted_modified_at,
    href,
    name,
    page_count,
    prepress_due_in,
    prepress_enqueued_at,
    print_count,
    print_provider,
    proof_type,
    publish_date,
    status,
    territory_name,
  } = job;

  const due_in = Math.round(prepress_due_in)
  const due_in_lingo = due_in > 0 ? `Due in ${Math.abs(due_in)} hours` : `Due ${Math.abs(due_in)} hours ago`

  return (
    <a className="list-group-item u-hover--raised" href={href}>
      <div className="d-flex w-100 align-items-center cursor-pointer row">
        <div className={"list-status-side-bar " + color_class} title={status}></div>
        <div className="d-flex flex-column align-content-center mx-3">
          {avatar && <Avatar user={avatar} />}
        </div>

        <div className="d-flex flex-column col-5 col-sm-3">
          {name}
          <small className="grey-text">{territory_name}</small>
        </div>

        <div className="d-none d-sm-flex flex-column col u-wrap">
          <small className="grey-text">{deadline_day}</small>
          <small className="grey-text">{publish_date}</small>
          <small className="grey-text" title={prepress_enqueued_at}>{due_in_lingo}</small>
        </div>

        <div className="d-none d-sm-flex flex-column col u-wrap">
          <small className="grey-text">{page_count} Pages</small>
          <small className="grey-text">{print_count} Copies</small>
          <small className="grey-text">{color_type}</small>
        </div>

        <div className="d-none d-lg-flex flex-column grey-text col-2 u-wrap">
          <small className="grey-text">{print_provider}</small>
          <small className="grey-text">{formatted_modified_at}</small>
          {proof_type && <small className="grey-text">{proof_type}</small>}
        </div>

        <div className="d-flex grey-text flex-column col-1 align-items-center ml-auto">
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
      </div>
    </a>
  )
}

export default PrepressListItem;
